module.exports = __webpack_public_path__ + "h5/static/img/ningmengweb-logo.26c5a90f.png";